import produce from "immer";
import { examSelectionTypes } from "./constants";

export const initialState = {
  isLoading: false,
  data: false,
  error: false,
};

export const ExamSelectionReducer = (state = initialState, action = {}) =>
  produce(state, (draft) => {
    switch (action.type) {
      case examSelectionTypes.GET_EXAMS_LIST_REQUEST:
        draft.isLoading = true;
        draft.error = false;
        draft.data = false;
        break;
      case examSelectionTypes.GET_EXAMS_LIST_SUCCESS:
        draft.data = action.payload;
        draft.isLoading = false;
        break;
      case examSelectionTypes.GET_EXAMS_LIST_ERROR:
        draft.error = action.error;
        draft.isLoading = false;
        break;
      default:
        draft = state;
        break;
    }
  });

export default ExamSelectionReducer;
